import React, { useState, useEffect } from 'react';
import { VscClose } from 'react-icons/vsc';
import axios from "axios";
import { UNMNG_SCTR_GB_LIST } from "../../helper/SecurityHelper";

export default function SelectSctrGb({ tbmList, setCompanyName, setCmpnySeq, setTab, selectedSctrGb, setSelectedSctrGb, setIsSctrGbPopOpen, setSnackbarTxt, signUp }: any) {
    const [sctrGbList, setSctrGbList] = useState<any>([]);
    const fn_retriveCmmnCodeList = async () => {
        const rtrnData = await axios.post('admin/api/cmmn/retriveCmmnCodeList', { codeGrpId: 'A002' });
        setSctrGbList(rtrnData.data);
    }
    useEffect(() => { fn_retriveCmmnCodeList(); }, []);

    const closeHandler = () => {
        setSelectedSctrGb('');
        setIsSctrGbPopOpen(false);
        if (tbmList) {
            setCompanyName('');
            setCmpnySeq(null);
            setTab('cmpny');
        }
    };

    const fn_moveNext = () => {
        if (!selectedSctrGb) {
            setSnackbarTxt('업종을 선택해 주십시오.');
            return;
        }
        setIsSctrGbPopOpen(false);
    };

    return (
        <div className='w-full h-[calc(100dvh)] absolute flex justify-center items-center bg-black bg-opacity-[70%] z-40 text-txtBlack'>
            <div className={(signUp || tbmList) ? 'w-[330px] h-[485px] md:w-[726px] md:h-[1200px] bg-white rounded-[5px] md:rounded-[12px] flex flex-col items-center' : 'w-[330px] h-[540px] md:w-[726px] md:h-[1300px] bg-white rounded-[5px] md:rounded-[12px] flex flex-col items-center'}>
                <div className='w-full h-44 md:h-[110px] bg-[#F5F5F5] flex justify-between items-center rounded-t-[5px] md:rounded-t-[12px]'>
                    <p className='ml-20 text-15 md:ml-50 md:text-37 font-preBold'>업종 선택</p>
                    <VscClose onClick={closeHandler} className='hover:cursor-pointer mr-15 text-22 md:mr-37 md:text-55' />
                </div>
                <div className='w-[255px] sm:w-[274px] md:w-[650px] mb-10 md:mb-[25px]'>
                    {sctrGbList.map((sctrGbData: any, idx: number) => {
                        return (
                            idx % 3 == 0 ?
                                <div key={idx} className='flex mt-15 md:mt-[37px]'>
                                    <WrkBtn selectedSctrGb={selectedSctrGb} setSelectedSctrGb={setSelectedSctrGb} >{sctrGbList[idx]}</WrkBtn>
                                    {sctrGbList.length - 1 >= idx + 1 ? <WrkBtn selectedSctrGb={selectedSctrGb} setSelectedSctrGb={setSelectedSctrGb} >{sctrGbList[idx + 1]}</WrkBtn> : null}
                                    {sctrGbList.length - 1 >= idx + 2 ? <WrkBtn selectedSctrGb={selectedSctrGb} setSelectedSctrGb={setSelectedSctrGb} >{sctrGbList[idx + 2]}</WrkBtn> : null}
                                </div> : null
                        )
                    })}
                    {!signUp && !tbmList ? <>
                        <hr className={'mt-15 md:mt-[37px]'} />
                        <div className='flex-column flex justify-between items-center mt-15 md:mt-[37px]'>
                            <div onClick={() => setSelectedSctrGb('COM')} className={selectedSctrGb === 'COM' ? 'w-full h-43 md:h-[107px] border border-point rounded-[5px] md:rounded-[12px] text-point text-13 leading-16 mx-5 md:text-32 md:leading-40 md:mx-[12px] flex justify-center items-center'
                                : 'w-full h-43 md:h-[107px] border border-[#D9D9D9] rounded-[5px] md:rounded-[12px] text-[#B1B1B1] text-13 leading-16 mx-5 md:text-32 md:leading-40 md:mx-[12px] flex justify-center items-center'}>주최사</div>
                        </div>
                    </> : null}
                </div>
                <button onClick={fn_moveNext} className='mt-auto mb-15 text-15 md:mb-37 md:text-37 font-preLight w-89 py-8 md:w-[222px] md:py-[20px] outline-none text-[#00A0FD] border-[#00A0FD] border-2 rounded-[5px] md:rounded-[12px]'>확인</button>
            </div>

        </div>
    );
}

const WrkBtn = ({ children, selectedSctrGb, setSelectedSctrGb }: any) => {
    return (
        <div onClick={() => setSelectedSctrGb(children.code)} className={selectedSctrGb === children.code ? 'w-82 h-43 md:w-[205px] md:h-[107px] border border-point rounded-[5px] md:rounded-[12px] text-point text-13 leading-16 mx-5 md:text-32 md:leading-40 md:mx-12 flex justify-center items-center'
            : 'w-82 h-43 md:w-[205px] md:h-[107px] border border-[#D9D9D9] rounded-[5px] md:rounded-[12px] text-[#B1B1B1] text-13 leading-16 mx-5 md:text-32 md:leading-40 md:mx-12 flex justify-center items-center'}>{children.codeNm}</div>
    )
}